export default __webpack_public_path__ + "static/media/gagal.6ff5700f.png";